let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_EXAMPLE": "Add Example",
    "LBL_VIEW_EXAMPLE": "View Example",
    "LBL_EXAMPLE_NAME": "Name",
    "LBL_BRANCH": "Branch",
    "LBL_EMAIL": "Email",
    "LBL_PHONE":"Phone",
    "LBL_GENDER":"Gender",
    "LBL_IMAGE":"Image",
    "LBL_DOB":"DOB",
    "LBL_QUALIFICATION":"Qalification",
    "LBL_HOBBIES":"Hobbies",
    "LBL_SINGING":"Singing",
    "LBL_DANCE":"Dancing",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
}

export default language;